import request from "@/utils/request";
import axios from "axios";
import store from "@/store";

export function userinfo(params) {
  return request.get('/userinfo', params, { login: true });
}
export function userEdit(params) {
  return request.post('/user/edit', params, { login: true });
}
export function userEditInfo(params) {
  return request.post('/user/edit', params, { login: true });
}
export function registerReset(params) {
  return request.post('/register/reset', params, { login: true });
}
export function graduationExamination(){

}
// 会员视频
export function userCourse(params) {
  return request.get('/user/course', params, { login: true });
}
//会员参赛作品
export function userVoteWorks(params) {
  return request.get('/user/voteWorks', params, { login: true });
}
export function userEditVoteWorks(id) {
  return request.get(`/user/voteWorks/detail/${id}`, {}, { login: true });
}
//会员作品取消参赛
export function userCancelVoteWorks(params) {
  return request.post('/user/voteWorks/cancel', params, { login: true });
}
export function userCertificates(params) {
  return request.get('/user/certificates', params, { login: true });
}

export function userCertificateDetail(id) {
  return request.get(`/user/certificates/${id}`, {}, { login: true });
}

export function downloadUserCertificatePdf(id) {
  return axios.get(`${process.env.VUE_APP_BASE_URL}/user/certificates/${id}/pdf`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${store.state.app.token || ""}`,
    },
  });
}
// 个人中心获取章节测试记录
export function chapterExaminationRecord(params) {
  return request.get('/artQuestionBank/chapterExamination/record', params, { login: true });
}

// 章节答题
export function chapterRandom(params) {
  return request.get('/artQuestionBank/chapter/random', params, { login: true });
}

// 毕业测试记录
export function graduationRecord(params) {
  return request.get('/artQuestionBank/graduation/record', params, { login: true });
}

// 测试题库
export function getExamList(params) {
  return request.get('/exam/list', params, { login: true });
}

// 测试答题
export function artQuestionBankExamination(params) {
  return request.post('/artQuestionBank/examination', params, { login: true });
}
/*
 * 我的考试
*/
export function getQuestList (data){
  return request.get('/exam/questionBank/list',data, { login: true });
}
  /*
   * 我的考试成绩
  */
  export function getAchievement(data) {
    return request.post('/exam/achievement',data, { login: true });
  }
  /*
   * 答案提交
  */
  export function getExamSubmit (data){
    return request.post('/exam/submit',data, { login: true });
  }
// 讨论话题分页查询
export function artDiscussionTopic(params) {
  return request.get('/artDiscussion/topic', params, { login: true });
}

// 讨论组评论查询
export function topicComment(params) {
  return request.get('/topicComment', params, { login: true });
}
// 新增讨论组评论
export function topicCommentPost(params) {
  return request.post('/topicComment', params, { login: true });
}

// 查询班级课程文件管理
export function artClassFile(params) {
  return request.get('/artClassFile', params, { login: true });
}

// 视频收藏列表
export function courseUserCollect(params) {
  return request.post('/relation/collect/list', params, { login: true });
}

// 工坊收藏列表
export function artWorkShopUserCollect(params) {
  return request.get('/artWorkShop/userCollect', params, { login: true });
}

// 新闻收藏列表
export function artNewsUserCollect(params) {
  return request.get('/artNews/userCollect', params, { login: true });
}

// 订单列表
export function orderList(params) {
  return request.get('/courseOrder/list', params, { login: true });
}

// 订单列表
export function userScore(params) {
  return request.get('/user/score', params, { login: true });
}


// 查询用户班级学习计划
export function leanPlan(params) {
  return request.get('/artUserSign/leanPlan', params, { login: true });
}

// 签到列表
export function artUserSign(params) {
  return request.get('/artUserSign', params, { login: true });
}

// /artUserSign

// 用户签到
export function artUserSignPost(params) {
  return request.post('/artUserSign', params, { login: true });
}

// 回复我的评论
export function replyMe(params) {
  return request.get('/replyMe', params, { login: true });
}
// 新增讨论话题
export function topic(params) {
  return request.post('/artDiscussion/topic', params, { login: true });
}
